import { CartButtonProps } from "@omni/types/components/props/cartButton.props";
import { cn } from "@omni/utils/styles";
import { useState } from "react";
import { useSelector } from "react-redux";

import { MiniCart } from "@/components/Cart/MiniCart/miniCart.component";
import { useCartItemsCount } from "@/components/CartButton/hooks/useCartItemsCount.hook";
import { HeaderButton } from "@/components/General/HeaderButton/headerButton.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import {
    useIsBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

const _CartButton = ({ invert, redirect, link, ...props }: CartButtonProps) => {
    const { count } = useCartItemsCount();

    const [isUpdatingCart, setIsUpdatingCart] = useState({});
    const [activeId, setActiveId] = useState("");
    const cart = useSelector(CartSelectors.getCart);
    const mobile = useSelector(HeaderSelectors.isMobile);
    const dispatch = useThunkDispatch();

    const isClient = useIsClientSide();

    const { matches: isLarge } = useIsBreakpoint("lg");

    const doRemoveFromCart = (id: string, quantity: number, free: boolean) => {
        setActiveId(id);
        setIsUpdatingCartForId(id, true);
        dispatch(CartModule.removeFromCart(id, quantity, free)).then(() =>
            setIsUpdatingCartForId(id, false)
        );
    };

    const setIsUpdatingCartForId = (id: string, isUpdatingCart: boolean) => {
        setIsUpdatingCart((cur: any) => ({
            ...cur.isUpdatingCart,
            [id]: isUpdatingCart
        }));
    };

    const alert = count ? (count < 100 ? count.toString() : "+99") : undefined;

    return (
        <HeaderButton
            {...props}
            invert={invert || (mobile && isClient)}
            hover={isLarge}
            addCloseCallback={true}
            hideChevron={true}
            link={cart?.items?.length ? redirect : link}
            alerts={alert}
            contentClassName={cn("tw:p-0")}
            withOverlay={!isLarge}
            iconPrefix={`${props.iconPrefix || "las"} tw:text-4xl!`}
        >
            <MiniCart
                removeFromCart={doRemoveFromCart}
                urlTarget={redirect}
                shoppingCart={cart}
                isUpdatingCart={isUpdatingCart}
                activeId={activeId}
            />
        </HeaderButton>
    );
};

export const CartButton = withBreakpoints(_CartButton);
